// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__PF4Vr","enabled":"Toggle_enabled__QLP0d","button":"Toggle_button__SXXLz"};